// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"858":"db2cbab1","914":"61114db3"}[chunkId] + ".chunk.js";
};